import { flexRender } from "@tanstack/react-table"

import { useTableContext } from "#Contexts/TableContext"
import cn from "#Utils/cn"

const ColumnFooters = ({ className = "" }) => {
  const { table, error, dataSize } = useTableContext()

  // Don't render footer if there's an error or no data
  if (error || dataSize === 0) {
    return null
  }

  const footerGroups = table.getFooterGroups()

  // Don't render if no footer groups defined
  if (!footerGroups || footerGroups.length === 0) {
    return null
  }

  return (
    <tfoot className={cn("sticky bottom-0 z-20 bg-surface-default", className)}>
      {footerGroups.map((footerGroup) => (
        <tr key={footerGroup.id}>
          {footerGroup.headers.map((header) => {
            const { minSize, maxSize, size } = header.column.columnDef
            const style = minSize || maxSize || size ? { width: header.getSize() } : {}

            return (
              <td
                key={header.id}
                colSpan={header.colSpan}
                className="c-table__td font-medium bg-surface-raised border-t"
                style={style}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(header.column.columnDef.footer, header.getContext())}
              </td>
            )
          })}
        </tr>
      ))}
    </tfoot>
  )
}

ColumnFooters.propTypes = {
  className: PropTypes.string,
}

export default ColumnFooters
